import { Box, Button, Card, TextField, Typography } from "@mui/material"
import Logo from "../../assets/logo2.png"
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../router/constants";
import { useState } from "react";
import { handleSignin } from "../../services/signin.service";

export function Login(){

    const navigate = useNavigate();

    const [formData, setFormData] = useState({
      email: "",
      senha: "",
    });

    const [ submitedError, setsubmitedError] = useState(false);

    const handleChange = (e:any) => {
      const { name, value } = e.target;
      setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit =  async () => {
      console.log("📦 Dados do formulário:", formData);
      if(formData.email.length < 1 ){
        setsubmitedError(true)

      }else{
        setsubmitedError(false)
      }

      if(formData.senha.length < 1 ){
        setsubmitedError(true)
      }else{
        setsubmitedError(false)
      }

      await handleSignin(formData.email, formData.senha)
    };

    return(
    <Box padding={4} sx={{
        display:"flex",
        flexDirection:"column",
        alignItems: "center",
        justifyContent:{
            xs: "center",
            sm:"space-between",
        },
        gap:5,
        background: "#fff",
        borderRadius: 2,
        width: "100%",
        maxWidth: 500,
        height:{
          xs: "100dvh",
          sm: "auto",  
        },
    }}>
        <Box display={"flex"} flexDirection={"column"} alignItems={"center"} gap={2} width={"100%"}>
            <img src={Logo} width={180}></img>
            <Typography variant="h6" fontWeight={500} color="#505152ff"> Fazer Login </Typography>
            <Typography variant="subtitle1" color="#8d8f92ff">Novo aqui? 
                <Button onClick={()=> navigate(`${ROUTES.SIGNUP}`)}>Crie uma conta</Button>
            </Typography>
        </Box>

        <Box display={"flex"} flexDirection={"column"} gap={3} width={"100%"}> 
            <TextField 
                label="E-mail" 
                fullWidth 
                name="email" 
                required 
                type="email" 
                value={formData.email} 
                onChange={handleChange}
                error={submitedError && !formData.email} 
                helperText={submitedError  && !formData.email ? "O e-mail é obrigatório" : ""}
            >
            </TextField>
            <Box>
                <TextField 
                    label="Senha" 
                    fullWidth 
                    type="password"
                    required 
                    name="senha" 
                    value={formData.senha} 
                    onChange={handleChange}
                    error={submitedError && !formData.senha} 
                    helperText={submitedError  && !formData.senha ? "A senha é obrigatória" : ""}
                >
                </TextField>
                <Button
                  sx={{marginTop:1}}
                  onClick={() => navigate(ROUTES.FORGOT_PASSWORD)}
                >
                  Esqueceu a senha?
                </Button>
            </Box>
        </Box>

        <Box width={"100%"}>
            <Button variant="contained" fullWidth sx={{height:"50px"}} onClick={handleSubmit}>Entrar</Button>
        </Box>
    </Box>
    )
}